import { render, staticRenderFns } from "./ArticleSlider.vue?vue&type=template&id=0a56d458"
import script from "./ArticleSlider.vue?vue&type=script&lang=js"
export * from "./ArticleSlider.vue?vue&type=script&lang=js"
import style0 from "./ArticleSlider.vue?vue&type=style&index=0&id=0a56d458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports